<template>
  <div class="overlay">
    <div class="upgrade-plan-wrapper">
      <div class="top">
        <div class="icon-wrapper">
          <i class="icon icon-lock"></i>
        </div>
        <h4 class="title">
          {{ $t('errors.plans.free_trial.expired_title') }}
        </h4>
        <p class="description">
          {{ $t('errors.plans.free_trial.expired_description') }}
        </p>
      </div>
      <div class="bottom">
        <button type="button" class="btn btn-flat added-btn btn-primary" @click="navigateSalesPage">{{ $t('errors.plans.free_trial.expired_button') }}</button>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      salesPageURL: "https://fanomena.io"
    }
  },
  methods: {
    navigateSalesPage() {
      window.location.href = this.salesPageURL
    }
  }
}
</script>
<style lang="scss">
.overlay {
  height: 100vh;
  width: 100vw;
  background-color: rgba(0,0,0,0.5);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 900;
}
.upgrade-plan-wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 1000;
  transform: translateX(-50%) translateY(-50%);
  height: 35%;
  width: 40%;
  background: #FFF;
  border-radius: 4px;
  min-width: 450px;
  max-height: 300px;
}
.top {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 75%;
  background: #FFD800;
  color: $onyx;
  flex-direction: column;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 0 10%;
  text-align: center;
}
.icon-wrapper {
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFF;
  border-radius: 12px;
}
.bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25%;
}

@media only screen and (max-width: 600px) {
  .upgrade-plan-wrapper {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// UpgradeFreeTrial.vue?4ed2e07e